import React from 'react';
import Input from 'components/ui2/Input';
import { noop } from 'utils/functions/noop';

const NomeServizioComponent = ({ value, setForm, modifica }) => (
  <Input
    inputValue={value}
    // placeholder="Inserisci il nome del corso"
    aria-label="Indicare l'eventuale nome con cui il vostro corso è comunemente conosciuto"
    label="Nome del corso"
    disabled={!modifica.campi}
    onChange={modifica.campi ? setForm : noop}
    color="blue"
  />
  );

NomeServizioComponent.displayName = 'Nome servizio component';

export const NomeServizio = NomeServizioComponent;
